import { Trans } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExpiresInFilter = ({ value, onChange }) => {
  const handleChange = e => {
    const newValue = e.target.value

    if (!newValue) {
      onChange(newValue)
    } else {
      if (Number(newValue) >= 0 && Number.isInteger(Number(newValue))) {
        onChange(Number(newValue))
      }
    }
  }

  return (
    <Styles.MainContainer>
      <InputWithLabel type="number" value={value} onChange={handleChange} />
      <p>
        <Trans i18nKey="expiresInFilterText">días o menos</Trans>
      </p>
    </Styles.MainContainer>
  )
}

export default ExpiresInFilter
